import React from "react";
import Cumpleaños from "../../components/1.6 cumpleaños/cumpleañosmes";
import ProxCumpleaños from "../../components/0. DashBoard/7. Cumpleaños/Cumpleaños";

const HomePage = () => {
  return (
    <>
      <div className="capsule" style={{ padding: "5px" }}>
        <ProxCumpleaños />
        
      </div>
      <div
        className="capsule"
        style={{ padding: "5px", marginBottom: "300px" }}
      >
        <Cumpleaños />
      </div>
    </>
  );
};

export default HomePage;
